module.exports = __webpack_public_path__ + "img/insu-qa-card-change.40be38f9.png";